import type { ReactNode } from 'react';

type Tone = 'error' | 'success' | 'info';

const TONES: Record<Tone, string> = {
  error: 'border-negative/40 bg-negative/10 text-ink',
  success: 'border-positive/40 bg-positive/10 text-ink',
  info: 'border-line bg-raised text-soft',
};

export function Alert({ tone = 'info', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <div
      /*
       * `role="alert"` on errors only. It interrupts a screen reader
       * immediately, which is right for "that password was wrong" and wrong for
       * a standing hint - an assertive region that is always present gets
       * re-announced on every render and becomes noise people learn to ignore.
       */
      role={tone === 'error' ? 'alert' : undefined}
      className={`rounded-[var(--radius-control)] border px-4 py-3 text-sm ${TONES[tone]}`}
    >
      {children}
    </div>
  );
}
